module.exports = __webpack_public_path__ + "img/73ed3911f4e8464b85b572a386c3a925.cbedff2d.png";